import React, { useEffect, useState, Fragment } from 'react';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import { LoadingMaterialTable } from "../../../Common/table";
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';

export const DuplicateTagVerificationListing = ({ duplicateTagData, handleClick }) => {
    const [tagListing, setTagListing] = useState([]);

    useEffect(() => {
        trackPromise(
            setTagListingCreationData()
        )
    }, [duplicateTagData]);

    async function setTagListingCreationData() {
        await setTagListing(duplicateTagData);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <LoadingMaterialTable
                title=""
                columns={[
                    {
                        title: "Tag Number", field: "tagNumber",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            whiteSpace: 'nowrap',
                            textAlign: "center"
                        }
                    },
                    {
                        title: "Weight Read Time", field: "weightReadTime",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            textAlign: "center"
                        }
                    },
                    {
                        title: "Gross Amount", field: "grossAmount",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            textAlign: "center"
                        }
                    },
                    {
                        title: "Net Amount", field: "netAmount",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            textAlign: "center"
                        }
                    },
                    {
                        title: "Actual Amount", field: "actualAmount",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            textAlign: "center"
                        }
                    },
                    {
                        title: "Total Deduction", field: "totalDeduction",
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            textAlign: "center"
                        }
                    },
                    {
                        title: "Edit",
                        render: (data) => (
                            <BorderColorTwoToneIcon
                                onClick={() => handleClick(data)}
                                style={{ cursor: "pointer" }}
                            >
                                {" "}
                            </BorderColorTwoToneIcon>
                        ),
                        cellStyle: {
                            width: 200,
                            maxWidth: 200,
                            textAlign: "center"
                        },
                        headerStyle: {
                            width: 20,
                            maxWidth: 20,
                            textAlign: "center"
                        }
                    },
                ]}
                data={duplicateTagData}
            />
        </Fragment>
    )
}